// extracted by mini-css-extract-plugin
module.exports = {"item":"eventitem_item__12gUm","imageWrap":"eventitem_imageWrap__3onKK","img__description":"eventitem_img__description__3EPci","eventName":"eventitem_eventName__2Edd8"};